import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  sidebarFirst: any[] = []
  sidebarSecond: any[] = []
  partners: any[] = []
  sidebarThird: any[] = []
  activeTab = ''
  section = ''
  isHeadQuarters = false
  unreadCount: number = 0
  isMobileMenuOpen = false
  constructor(private router: Router, private authService: AuthservicesService, private notifSvc: NotificationService) {
  }

  ngOnInit(): void {
    this.sidebarFirst = environment.sidebar;
    this.sidebarSecond = environment.sideBarSecond;

    // Initialize sidebarThird based on HQ flag (default false until API confirms)
    this.sidebarThird = (environment.sideBarThird || []).filter(i => {
      const route = (i?.route || '').toString();
      // Always show association-manager and partner-manager regardless of headquarters status
      if (route === '/association-manager' || route === 'association-manager' || route === '/partner-manager' || route === 'partner-manager') {
        return true;
      }
      const hide = route === '/association-manager' || route === 'association-manager' || route === '/partner-manager' || route === 'partner-manager';
      return this.isHeadQuarters ? true : !hide;
    });

    const currentIdRaw: any = this.authService?.currentUserValue?.id || this.authService?.currentUserValue?._id;
    const currentId: string = currentIdRaw != null ? String(currentIdRaw) : '';
    if (currentId) {
      this.authService.communitydetails(currentId).subscribe(
        (res: any) => {
          const data = res?.data || res;
          this.isHeadQuarters = !!(data && (data.isHeadQuarters === true || data.isHeadQuarter === true));

          // Recompute sidebarThird after we know HQ status
          const toHide = new Set(['/association-manager', 'association-manager', '/partner-manager', 'partner-manager']);
          this.sidebarThird = (environment.sideBarThird || []).filter(i => {
            const route = (i?.route || '').toString();
            // Always show association-manager and partner-manager regardless of headquarters status
            if (route === '/association-manager' || route === 'association-manager' || route === '/partner-manager' || route === 'partner-manager') {
              return true;
            }
            return this.isHeadQuarters ? true : !toHide.has(route);
          });
        },

        err => {
          this.isHeadQuarters = false;
          const toHide = new Set(['/association-manager', 'association-manager', '/partner-manager', 'partner-manager']);
          this.sidebarThird = (environment.sideBarThird || []).filter(i => {
            const route = (i?.route || '').toString();
            // Always show association-manager and partner-manager regardless of headquarters status
            if (route === '/association-manager' || route === 'association-manager' || route === '/partner-manager' || route === 'partner-manager') {
              return true;
            }
            return !toHide.has(route);
          });
        }
      );
    }

    // Setup socket to receive real-time notifications
    try {
      if (currentId) {
        this.notifSvc.connect(currentId);
        this.notifSvc.on('notification').subscribe((payload: any) => {
          // Backend emits globally; only count if directed to current user
          const toId: string = payload?.to?._id ? String(payload.to._id) : (payload?.to ? String(payload.to) : '');
          if (toId && toId === currentId) {
            this.unreadCount = (this.unreadCount || 0) + 1;
          }
        });
      }
    } catch { /* no-op */ }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  logout() {
    this.activeTab = 'logout';
    this.closeMobileMenu();

    localStorage.removeItem('checked');
    this.router.navigateByUrl('/login');
    this.authService.logout();

  }

  subitem(key: string) {
    this.section = key
  }

  ngOnDestroy(): void {
    try { this.notifSvc.disconnect(); } catch { /* no-op */ }
  }
}
